/** App routes — keep in sync with React Router paths in App.js */

export const ROUTE_HOME = "/home";
export const ROUTE_PALLET_GROUP_ASSIGNMENT = "/pallet-group-assignment";
